/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React from 'react'

import { useHandleHover } from 'libs/hooks/useHandleHover'
import { TextInputContainerBase } from 'ui/designSystem/TextInput/TextInputContainerBase'
import { TextInputContainerBaseProps } from 'ui/designSystem/TextInput/types'

export const TextInputContainer: React.FC<TextInputContainerBaseProps> = (props) => {
  const hoverProps = useHandleHover()

  return <TextInputContainerBase {...props} {...hoverProps} isHover={hoverProps.isHover} />
}
